export const imageModalDataSet = { cy: 'image-modal' };

export const imageModalCloseButtonDataSet = { cy: 'image-modal-close-button' };
